export const AccountUtil = {
  displayBenchName(account = {}) {
    return `${account?.calculatedName || ''} bench`.trim();
  },
};
